import { Component, OnInit, Input } from '@angular/core';
import { TranslatePipe } from 'app/pipes/translate.pipe';


@Component({
  selector: 'ota-dialog-error',
  templateUrl: './dialog-error.component.html',
  styleUrls: ['./dialog-error.component.scss']
})
export class DialogErrorComponent implements OnInit {
  @Input('text') text: string;
  @Input('text') subText: string;

  constructor() {}

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// ./src/app/components/modal/dialog-error/dialog-error.component.ts